import { AxiosInstance } from "axios"
import { Entity, EntitySimple, EntityTypeFilter, EntityWithExtendedDetails } from "./supportEntitiesTypes"
import { ServiceResponse } from "../../../../core/api/apiTypes"

export enum SupportEntityQuery {
    LIST = "entities-list-for-support",
    LIST_SIMPLE = "entities-simple-list-for-support",
    DETAILS = "entities-details-for-support",
    DETAILS_FOR_ENTITY = "details-for-entities",
}

export type FetchSupportEntityResponse = Readonly<{
    entities: Entity[]
}>

export type FetchSupportEntitySimpleResponse = Readonly<{
    entities: EntitySimple[]
}>

export type FetchSupportEntityByIdResponse = Readonly<{
    entity: EntityWithExtendedDetails
}>

type FetchEntitiesParams = Readonly<{
    entityType: EntityTypeFilter
    isActive: boolean
}>

type FetchEntitiesSimpleParams = Readonly<{
    type: EntityTypeFilter
}>

type FetchEntityDetailsParams = Readonly<{
    entityId: number
}>
type DeleteEntityDetailsParams = Readonly<{
    entityId: number
}>

export async function fetchEntities(
    { entityType, isActive }: FetchEntitiesParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchSupportEntityResponse> {
    const url = "/entities"

    const params: Record<string, any> = { isActive }

    if (entityType !== EntityTypeFilter.ALL) {
        params["type"] = entityType
    }

    const response = await axios.get(url, {
        signal,
        params,
    })

    return response.data
}

export async function fetchEntitiesSimple(
    { type }: FetchEntitiesSimpleParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchSupportEntitySimpleResponse> {
    const url = "/entities/simple"

    const response = await axios.get(url, {
        params: {
            type,
        },
        signal,
    })

    return response.data
}

export async function fetchEntityDetailsById(
    { entityId }: FetchEntityDetailsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchSupportEntityByIdResponse> {
    const url = `/entities/${entityId}`

    const response = await axios.get(url, { signal })

    return response.data
}

export async function deleteEntity(
    { entityId }: DeleteEntityDetailsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const url = `/entities/${entityId}`

    const response = await axios.delete(url, {
        signal,
    })

    return response.data
}
